/* src/app/components/main-content/main-content.component.scss */
.fixlink a {
  text-decoration: none;
  color: black;
}
.sidebar {
  position: fixed;
  top: 10px;
  right: 10px;
}
.myBar {
  height: inherit;
  background-color: transparent;
  width: 36px;
  border-radius: 0.25rem;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.myList {
  height: inherit;
  background-color: white;
}
.myEmployee {
  margin-left: 0;
  width: calc(100% - 250px);
}
.myEmployeeFullSize {
  width: calc(100% - 30px);
}
.myEmployeeBg {
  background-color: white;
  border-radius: 0.25rem;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  min-height: 200px;
}
.vertical-text {
  display: inline-block;
}
.backdrop-visible {
  z-index: 945;
}
.backdrop-visible-sidebar {
  z-index: 960;
}
.myBackdrop {
  background-color: lightgrey;
  opacity: 0.5;
}
.mat-divider-vertical {
  width: 1px;
  background-color: rgb(65, 65, 65);
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 2;
}
.mat-divider-vertical .mat-mdc-icon-button {
  position: fixed;
}
.mat-divider-vertical .mat-icon {
  font-size: 36px;
  color: rgb(65, 65, 65);
}
.mat-divider-vertical.backdrop-visible {
  z-index: 962 !important;
}
.content-left {
  min-width: 350px;
  max-width: 500px;
  background-color: white;
}
/*# sourceMappingURL=main-content.component-V2R5YCKO.css.map */
